<script>
  import {mapState, mapActions, mapGetters} from 'vuex'
  export default {
    computed: {
      ...mapGetters({
        links: 'user/wiki/video'
      })
    }
  }
</script>
<template>
  <div class="mag-header-video" :class="{'active': links.length}">
    <template v-if="!links.length">
      <i class="mag-icon-nav-top-video"></i>
    </template>
    <template v-else>
      <el-dropdown trigger="click" title="Перейти к просмотру видео-уроков">
        <i class="mag-icon-nav-top-video"></i>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item v-for="link in links" :key="link.IconLink+link.PageName"><a class="mag-header__poper-link" :href="link.IconLink" target="_blank">{{link.PageName}}</a></el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </template>
  </div>
</template>
<style lang="scss">
  .mag-header-video{
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    width: 40px;
    font-size: 20px;
    cursor: default;
    &.active{
      cursor: pointer;
    }
  }
</style>
